import { Injectable } from "@angular/core";
import { BehaviorSubject, combineLatest, from, Observable, of } from "rxjs";
import { Evidencia, MOCK_EVIDENCIAS } from "./models/evidencia";
import { HttpClient } from "@angular/common/http";
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  shareReplay,
  switchMap,
  tap,
} from "rxjs/operators";
import { normalizedContains } from "src/app/asistencia-general/_models/asistencia-autorizacion";

const API_EVIDIDENCIAS = of([MOCK_EVIDENCIAS]);

const LIMIT_LOW = 25;
const LIMIT_MID = 50;
const LIMIT_HIGH = 100;
const LIMITS = [LIMIT_LOW, LIMIT_MID, LIMIT_HIGH];
export const DEFAULT_LIMIT = LIMIT_MID;
export const DEFAULT_SEARCH = "";
export const DEFAULT_PAGE = 0;
export const DEFAULT_CURSO = [];
export const DEFAULT_ESTADO = 0;
export const DEFAULT_FECHA_SOLICITUD = "";
export const DEFAULT_FECHA_INICIO = "";
export const DEFAULT_FECHA_FIN = "";

@Injectable({
  providedIn: "root",
})
export class RetroalimentacionReportService {
  // private errorMsgeBS = new BehaviorSubject<string>("");
  // errorMsge$ = this.errorMsgeBS.asObservable();

  private prosearchBS = new BehaviorSubject(DEFAULT_SEARCH);
  prosearch$ = this.prosearchBS.asObservable();

  private matsearchBS = new BehaviorSubject(DEFAULT_SEARCH);
  matsearch$ = this.matsearchBS.asObservable();

  private loadingBS = new BehaviorSubject<boolean>(true);
  loading$ = this.loadingBS.asObservable();

  private pageSizeBS = new BehaviorSubject<number>(LIMIT_LOW);
  pageSize$ = this.pageSizeBS.asObservable();

  private pageSizeOptionsBS = new BehaviorSubject<number[]>(LIMITS);
  pageSizeOptions$ = this.pageSizeOptionsBS.asObservable();

  private pageIndexBS = new BehaviorSubject<number>(DEFAULT_PAGE);
  pageIndex$ = this.pageIndexBS.asObservable();

  // private evidenciasBS = new BehaviorSubject<Evidencia[]>(MOCK_EVIDENCIAS);
  // evidencias$ = this.evidenciasBS.asObservable();

  params$ = combineLatest([
    this.prosearchBS.pipe(debounceTime(500)),
    this.matsearchBS.pipe(debounceTime(500)),
    this.pageIndexBS.pipe(debounceTime(500)),
    this.pageSizeBS,
  ]).pipe(
    distinctUntilChanged((pre, curr) => {
      return JSON.stringify(pre) === JSON.stringify(curr);
    }),
    map(([prosearch, matsearch, pageIndex, pageSize]) => {
      const params: any = {};

      if (prosearch.toString().length) {
        params.profesorName = prosearch;
      }

      if (matsearch.toString().length) {
        params.materia = matsearch;
      }

      if (pageIndex > -1) {
        params.pageIndex = pageIndex;
      }

      if (pageSize > 0) {
        params.pageSize = pageSize;
      }

      return params;
    })
  );

  private evidenciasData$ = this.params$.pipe(
    switchMap(
      (params) => of(MOCK_EVIDENCIAS) ),
    tap(() => this.loadingBS.next(false)),
    // shareReplay(1)
  );

  evidenciasResult$: Observable<Evidencia[]> = combineLatest([
    this.evidenciasData$.pipe(map((d) => d.evidencias)),
    this.prosearch$,
    this.matsearch$
  ]).pipe(
    map(([evidencias, nombreBuscar, materiaBuscar]) => {

      return evidencias.filter((evidencia) =>
          normalizedContains(evidencia.profesorName, nombreBuscar ?? "") &&
          normalizedContains(evidencia.materia, materiaBuscar ?? ""))
    }
    )
  );

  length$: Observable<number> = this.evidenciasData$.pipe(
    map((data) => data.length),
  );


// observables cuando est el API

  // private evidenciasResponse$ = this.params$.pipe(
  //   //tap(()=>this.loadingBS.next(false)),
  //   debounceTime(500),
  //   switchMap((params)=> this.http.get(`${API_EVIDIDENCIAS}`,{params: params})
  //   ),
  //   shareReplay(1),
  // );

  // evidenciasResult$: Observable<Evidencia[]> = this.evidenciasResponse$.pipe(
  //   map((res: any) => res.data.results)
  // );

  // length$: Observable<number> = this.evidenciasResponse$.pipe(
  //   map((res: any) => res.data.total)
  // );



  constructor(private http: HttpClient) {}

  searchProfesor(prof: string) {
    this.prosearchBS.next(prof);
  }

  searchMateria(mat: string) {
    this.matsearchBS.next(mat);
  }

  setPageSize(pageSize: number) {
    if (this.pageSizeBS.value !== pageSize) {
      this.pageIndexBS.next(0);
      this.pageSizeBS.next(pageSize);
    }
  }

  setPageIndex(pageIndex: number) {
    if (this.pageIndexBS.value !== pageIndex) {
      this.pageIndexBS.next(pageIndex);
    }
  }
}
